<template>
	<div v-show="show">
		<div class="login">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box login-box1">
				<div class="login-box1-title">{{$t('MAIN_WEB_WELCOME_TO_LOGIN',{text:'欢迎登录'})}}！</div>
				<div class="login-box1-tip" v-if="organList && organList.length">
					{{$t('MAIN_WEB_YOUR_ACCOUNT_BELONGS_TO_MULTIPLE_ORGANIZATIONS_PLEASE',{text:'您的账号属于多个组织，请选择要登录的组织'})}}
				</div>
				<div class="login-box1-tip" v-else>{{$t('MAIN_WEB_YOU_DO_NOT_HAVE_AN_ORGANIZATION_YET',{text:'你还没有组织，请联系管理员添加权限。'})}}</div>
				<ul class="login-box1-list" v-if="organList && organList.length">
					<li v-for="(item, index) in organList" :key="index" @click="setUserOrgan(item)">
						{{ item.name }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'organ',
	props:{
		solutionName:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			organList: [],
			show: false,
			loginImg: '',
      		defaultImg: require('../../assets/images/pexels.png'),
		}
	},
	mounted() {
		this.loginImg = localStorage.getItem('loginImg') || this.defaultImg;
		this.getFindOrganList()
	},
	methods: {
		getFindOrganList() {
			this.$api.operate.getFindOrganList({}).then((res) => {
				if (res.code != 0) {
					this.$message.error(this.$t('MAIN_WEB_FAILED_TO_OBTAIN_TENANT_INFORMATION',{text:'获取租户信息失败'}))
					return
				}
				if (res.data && res.data.length) {
					// 人社分销考试只查看人社的
					if(localStorage.getItem('theme')=='renshefenguan' && res.data.length>0){
						const temp = res.data.filter(item=>{
							return item.name == this.solutionName;
						})
						this.organList = temp;
					}else{
						this.organList = res.data;
					}
					if (this.organList.length === 1) {
						this.setUserOrgan(this.organList[0],1)
					}
					if (this.organList.length != 1) {
						this.show = true;
					}
				}
			})
		},

		async setUserOrgan(item,organListLength) {
			localStorage.setItem('name', item.name)
			localStorage.setItem('organ', item.organ)
			localStorage.setItem('actor', item.actor)
			sessionStorage.setItem('name', item.name)
			sessionStorage.setItem('organ', item.organ)
			sessionStorage.setItem('actor', item.actor)
			item.channel && localStorage.setItem('channel', item.channel)
			item.channel && sessionStorage.setItem('channel', item.channel)
			if (!item.status) {
                this.$message.error(this.$t('MAIN_WEB_THE_CURRENT_TENANT_HAS_BEEN_DISABLED',{text:'当前租户已被禁用'}))
                if(organListLength === 1){
                    this.$emit('changeShowOrgan', false)
                }
				return
			}
			this.$router.replace('/')
		},
	},
}
</script>

<style lang="stylus" scoped>
@import 'index.styl';
</style>
